import { Catalog } from "./catalog";

export class ticketTypeFileRestriction {
  file_types: string[];
  quantity_range: string;

  constructor(data: any) {
    this.file_types = data.file_types || [];
    this.quantity_range = data.quantity_range;
  }

  get quantity_range_start(): number | null {
    const match = this.quantity_range.match(/^(\d+)\.\.(\d+)?$/) || this.quantity_range.match(/^(\d+)\.\.$/);
    return match ? parseInt(match[1], 10) : null;
  }

  get quantity_range_end(): number | null {
    const match = this.quantity_range.match(/^\d+\.\.(\d+)$/);
    return match ? parseInt(match[1], 10) : null;
  }

  set quantity_range_start(value: number | null) {
    const end = this.quantity_range_end;
    if (value !== null && end !== null) {
      this.quantity_range = `${value}..${end}`;
    } else if (value !== null) {
      this.quantity_range = `${value}..`;
    } else if (end !== null) {
      this.quantity_range = `..${end}`;
    } else {
      this.quantity_range = '1..1';
    }
  }

  set quantity_range_end(value: number | null) {
    const start = this.quantity_range_start;
    if (start !== null && value !== null) {
      this.quantity_range = `${start}..${value}`;
    } else if (start !== null) {
      this.quantity_range = `${start}..`;
    } else if (value !== null) {
      this.quantity_range = `..${value}`;
    } else {
      this.quantity_range = '1..1';
    }
  }


}

export class TicketType extends Catalog {
  validationKey: string = "ticket_type";
  default: string;
  require_receipt: boolean;

  constructor(data: any) {
    super(data);
    this.require_receipt = data.require_receipt;
  }

  protected get saveProp(): string[] {
    return super.saveProp.concat(["default", "require_receipt"]);
  }

  get isDefault(): boolean {
    return this.default == 't';
  }

  set isDefault(value: boolean) {
    this.default = value ? 't' : 'f';
  }

  get file_restrictions(): ticketTypeFileRestriction[] {
    return this.config ? this.config.file_restrictions || [] : [];
  }

  get can_count_file_rows(): boolean {
    return this.config ? this.config.count_file_rows || false : false;
  }

  get close_message(): string {
    return this.config ? this.config.close_message || "" : "";
  }

  get available_file_types(): string[] {
    const typesSet = new Set<string>();
    this.file_restrictions.forEach(restriction => {
      restriction.file_types.forEach(type => typesSet.add(type));
    });
    return Array.from(typesSet);
  }

}
